<template>
    <div :class="$style['load-more']">
        <Button @click="$emit('click')"><slot></slot></Button>
    </div>
</template>
<script>
    import Button from '../Button/Button';

    export default {
        components: {
            Button
        }
    }
</script>
<style lang="scss" module>
    .load-more {
        @include margin-level(top, green);
    }
</style>
